import "./ProfileFoundCardComponent.scss";
import AvatarComponent from "../avatar/AvatarComponent";
import {ImageConfig} from "../../../constants";
import React from "react";
import CommonService from "../../services/common.service";

interface ProfileFoundCardComponentProps {
    profileDetails: any
    permissionType?: string;
}

const ProfileFoundCardComponent = (props: ProfileFoundCardComponentProps) => {
    const {profileDetails, permissionType} = props;

    return (
        <div className={'profile-found-card-component'}>
            <div className={'profile-found-card'}>
                <div className={'profile-image-wrapper'}>
                    <AvatarComponent title={profileDetails?.first_name + " " + profileDetails?.last_name}/>
                </div>
                <div className={'profile-content-wrapper'}>
                    <div className={'profile-name'}>{profileDetails?.first_name + " " + profileDetails?.last_name}</div>
                    <div className={"profile-sub-text-wrapper"}>
                        <div className="profile-contact-section phone-info">
                            <div><ImageConfig.ProfileFoundPhoneIcon/></div>
                            <div className="contact-info-text">
                                {CommonService.formatPhoneNumber(profileDetails?.primary_contact_info?.phone)}
                            </div>
                        </div>
                    </div>
                    {permissionType && <div className={"profile-sub-text-wrapper"}>
                        <div className="profile-contact-section phone-info">
                            <div><ImageConfig.HandShakeIcon/></div>
                            <div className="contact-info-text">
                                {permissionType === 'non_mutual' && 'One-Way Access'}
                                {
                                    permissionType === 'mutual' && 'Mutual Access'
                                }
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );

};

export default ProfileFoundCardComponent;
